export const categories = [
  {
    slug: "mingchangmian",
    name: "名场面",
    shortName: "名场面",
    description: "把那些让人反复回放的高光瞬间收进一页，按时间线梳理值得再刷一次的经典画面。",
    icon: "ri-star-smile-line",
    tone: "primary",
  },
  {
    slug: "baoxiao",
    name: "爆笑高能",
    shortName: "爆笑",
    description: "从综艺到直播，把笑到停不下来的片段整理成集，专治心情低落和无聊午后。",
    icon: "ri-emotion-laugh-line",
    tone: "accent",
  },
  {
    slug: "xiaotiangua",
    name: "小甜瓜",
    shortName: "小甜瓜",
    description: "不吵不闹的轻甜内容，镜头边角的温柔互动与真诚回应，慢慢看会心一笑。",
    icon: "ri-heart-3-line",
    tone: "secondary",
  },
  {
    slug: "lezi",
    name: "乐子合集",
    shortName: "乐子",
    description: "按周打包的轻松乐子清单，通勤、摸鱼、睡前随手点开，一分钟接住快乐。",
    icon: "ri-gift-2-line",
    tone: "primary",
  },
];